<form [formGroup]="form" ngNativeValidate>
    <div *ngIf="!isGuest && form.get('title')" class="form-group required">
        <label class="control-label" for="checkout-email">{{"address_title"|translate}}</label>
        <input type="text" class="form-control" [placeholder]="'address_title'|translate" formControlName="title"
            required>
    </div>
    <div class="row">
        <div class="form-group col-md-6 required">
            <label class="control-label" for="checkout-email">{{"name"|translate}}</label>
            <input type="text" class="form-control" [placeholder]="'name'|translate" formControlName="name" required>
        </div>
        <div class="form-group col-md-6 required">
            <label class="control-label" for="checkout-phone">{{"phone"|translate}}</label>
            <input type="tel" class="form-control" [placeholder]="'phone'|translate" formControlName="phone" (keypress)="onPhoneKeyPress($event)" (input)="onPhoneInput($event)" (paste)="onPhonePaste($event)" required>
        </div>
    </div>
    <div class="row">
        <div class="form-group col-md-6 required">
            <label class="control-label" for="checkout-country">{{"country"|translate}}</label>
            <select [value]="form.controls['countryId'].value" formControlName="countryId" class="form-control"
                (change)="onCountryChange($event)" required>
                <option [value]="null" disabled> -- {{"select_country"|translate}} -- </option>
                <option *ngFor="let country of countries" [value]="country._id">{{country.name[lang]}}</option>
            </select>
        </div>
        <div class="form-group col-md-6 required">
            <label class="control-label" for="checkout-street-address">{{"city"|translate}}</label>
            <select [value]="form.controls['cityId'].value" formControlName="cityId" class="form-control"
                (change)="onCityChange($event)" required>
                <option [value]="null" disabled> -- {{"select_city"|translate}} -- </option>
                <optgroup *ngFor="let area of country?.areas" [label]="area.name[lang]">
                    <option *ngFor="let city of sortByCityName(area?.cities)" [attr.data-areaId]="area._id"
                        [value]="city._id">{{city.name[lang]}}</option>
                </optgroup>
            </select>
        </div>
    </div>
    <div class="row">
        <div class="form-group col-md-6">
            <label class="control-label" for="checkout-postcode">{{"flat"|translate}}</label>
            <input type="text" class="form-control" formControlName="flat">
        </div>
        <div class="form-group col-md-6 required">
            <label class="control-label" for="checkout-city">{{"building"|translate}}</label>
            <input type="text" class="form-control" formControlName="building" required>
        </div>
    </div>
    <div class="row">
        <div class="form-group col-md-6 required">
            <label class="control-label" for="checkout-address">{{"street"|translate}}</label>
            <input type="text" class="form-control" formControlName="road" required>
        </div>
        <div class="form-group col-md-6 required">
            <label class="control-label" for="checkout-state">{{"block"|translate}}</label>
            <input type="text" class="form-control" formControlName="block" required>
        </div>
    </div>

<!--     <div>
        <mat-form-field floatLabel="always" appearance="outline" class="flex-auto w-full">
            <mat-label>{{"enter_address"|translate}}*</mat-label>
            <input (keydown.enter)="$event.preventDefault()" [placeholder]="'search_location'|translate"
                autocorrect="off" autocapitalize="off" spellcheck="off" type="text" #search matInput>
        </mat-form-field>

        <div *ngIf="apiLoaded | async">
            <google-map height="500px" width="100%" [zoom]="zoom" [center]="center" [options]="options"
                (mapDrag)="mapCenter()">
                <map-marker #markerElem [position]="marker.position" [options]="marker.options"> </map-marker>
            </google-map>
        </div>
    </div> -->
</form>